const styles = (theme) => ({
  root: {
  },
  summary: {
    '& p': {
      marginTop: theme.spacing.unit,
    },
  },
  details: {
    textAlign: 'left',
    '& ul, & ol': {
      marginLeft: 0,
      paddingLeft: 0,
      listStylePosition: 'inside',
    },
  },
  expansionPanelDetails: {
    padding: 0,
  },
  expansionContent: {
    textAlign: 'left',
    '& p:first-child': {
      marginTop: 0,
    },
    '& ul, & ol': {
      marginLeft: 0,
      paddingLeft: 0,
      listStylePosition: 'inside',
    },
  },
});

export default styles;
